import styled, { css } from 'styled-components';

export const ToggleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  label {
    margin-bottom: 12px;
    color: var(--grey-100);
  }
`

export const ToggleButton = styled.div`
  display: flex;
  flex-direction: row;
`

type Props = {
  isPerson?: boolean
}

export const Button = styled.button<Props>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 6vh;
  font-family: Inter, sans-serif;
  font-size: 0.9rem;
  color: var(--white);
  background-color: var(--black-100);
  border: 1px solid var(--grey-300);

  img {
    width: 1rem;
    height: 1rem;
  }

  &:first-of-type {
    border-radius: 4px 0px 0px 4px;
  }

  &:last-of-type {
    border-radius: 0px 4px 4px 0px;
  }

  ${({isPerson}) => isPerson && css`
    border-color: var(--primary);
  `}
`